import {useEffect,useState} from 'react';

// A one-shot timer updates the display at expiry, without polling the provider.
export function useExpiry(expiresAt?:string|null):number {
  const [now,setNow]=useState(Date.now);
  useEffect(()=>{
    setNow(Date.now());
    const expiry=Date.parse(expiresAt??'');
    if(!Number.isFinite(expiry))return;
    let timer:ReturnType<typeof setTimeout>;
    const tick=()=>{
      const current=Date.now();setNow(current);
      if(expiry>current)timer=setTimeout(tick,Math.min(expiry-current+20,2_147_483_647));
    };
    tick();return()=>clearTimeout(timer);
  },[expiresAt]);
  return Math.max(now,Date.now());
}
